/* New Chikan Sagar — shopping layer for Shopify.
   Bag (Ajax Cart API), wishlist (stored in the browser), product options,
   recommendations and collection filters. */
(function () {
  "use strict";
  var CFG = window.NCS || {};
  var R = CFG.routes || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ------------------------------------------------------------ money */
  function group(n) { return n.replace(/\B(?=(\d{3})+(?!\d))/g, ","); }
  function formatMoney(cents) {
    cents = Math.round(Number(cents) || 0);
    var fmt = CFG.moneyFormat || "₹{{amount}}";
    var whole = Math.floor(cents / 100), frac = ("0" + (cents % 100)).slice(-2);
    var trim = CFG.hideDecimals && frac === "00";
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/), key = m ? m[1] : "amount", val;
    switch (key) {
      case "amount_no_decimals": val = group(String(Math.round(cents / 100))); break;
      case "amount_with_comma_separator": val = group(String(whole)).replace(/,/g, ".") + (trim ? "" : "," + frac); break;
      case "amount_no_decimals_with_comma_separator": val = group(String(Math.round(cents / 100))).replace(/,/g, "."); break;
      case "amount_with_apostrophe_separator": val = group(String(whole)).replace(/,/g, "'") + (trim ? "" : "." + frac); break;
      default: val = group(String(whole)) + (trim ? "" : "." + frac);
    }
    var out = fmt.replace(/\{\{\s*\w+\s*\}\}/, val);
    var tmp = document.createElement("div"); tmp.innerHTML = out;
    return tmp.textContent;
  }
  window.NCS_formatMoney = formatMoney;

  /* ------------------------------------------------------------ toast */
  function toast(msg) {
    var t = $("#toast"); if (!t) return;
    $("[data-toast-msg]", t).textContent = msg;
    t.classList.add("is-on");
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove("is-on"); }, 2600);
  }
  window.NCS_toast = toast;

  /* ------------------------------------------------------------ bag */
  function paintCartCount(n) {
    $$("[data-cart-count]").forEach(function (b) { b.textContent = n; b.style.display = n > 0 ? "" : "none"; });
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) { var e = new Error(data.description || data.message || "Something went wrong. Please try again."); e.data = data; throw e; }
        return data;
      });
    });
  }
  function refreshCount() {
    return fetch((R.cart || "/cart") + ".js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paintCartCount(c.item_count); return c; })
      .catch(function () {});
  }
  function addToBag(id, qty, title) {
    return postJSON((R.cartAdd || "/cart/add") + ".js", { items: [{ id: Number(id), quantity: qty || 1 }] })
      .then(function () { toast((title ? title + " " : "") + "added to your bag"); return refreshCount(); });
  }
  window.NCS_addToBag = addToBag;

  document.addEventListener("click", function (e) {
    var q = e.target.closest("[data-quickadd]");
    if (!q) return;
    e.preventDefault();
    q.disabled = true;
    addToBag(q.dataset.quickadd, 1, q.dataset.title)
      .catch(function (err) { toast(err.message); })
      .then(function () { q.disabled = false; });
  });

  /* ------------------------------------------------------------ wishlist */
  var WKEY = "ncs_wishlist_v1";
  function readWish() { try { var v = JSON.parse(localStorage.getItem(WKEY)); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function writeWish(list) { try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {} }
  function paintWish() {
    var list = readWish();
    $$("[data-wish-count]").forEach(function (b) { b.textContent = list.length; b.style.display = list.length ? "" : "none"; });
    $$("[data-wish]").forEach(function (b) {
      var on = list.indexOf(b.dataset.wish) > -1;
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
      if (b.hasAttribute("data-wish-label")) b.textContent = on ? "♥ Saved" : "♡ Save";
    });
  }
  function toggleWish(handle) {
    var list = readWish(), i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.unshift(handle);
    writeWish(list); paintWish();
    return i === -1;
  }
  document.addEventListener("click", function (e) {
    var w = e.target.closest("[data-wish]");
    if (!w) return;
    e.preventDefault();
    var on = toggleWish(w.dataset.wish);
    toast(on ? "Saved to your wishlist" : "Removed from your wishlist");
    var grid = $("[data-wishgrid]");
    if (grid && !on) {
      var card = w.closest(".pcard");
      if (card && grid.contains(card)) { card.remove(); if (!$(".pcard", grid)) renderWishlist(); }
    }
  });
  function emptyWish(grid) {
    grid.innerHTML = '<div class="empty" style="grid-column:1/-1"><h3>Nothing saved yet</h3><p>Tap the heart on any piece to keep it here.</p><a class="btn btn--ghost btn--sm" href="' + (grid.dataset.emptyLink || "/collections/all") + '">Browse the collection</a></div>';
  }
  function renderWishlist() {
    var grid = $("[data-wishgrid]"); if (!grid) return;
    var list = readWish();
    if (!list.length) { emptyWish(grid); return; }
    var root = (R.root || "/").replace(/\/$/, "");
    Promise.all(list.map(function (h) {
      return fetch(root + "/products/" + encodeURIComponent(h) + "?section_id=wishlist-card")
        .then(function (r) { return r.ok ? r.text() : ""; })
        .then(function (html) {
          if (!html) return null;
          var d = document.createElement("div"); d.innerHTML = html;
          return $(".pcard", d);
        }).catch(function () { return null; });
    })).then(function (cards) {
      var found = cards.filter(Boolean);
      // Forget products that were deleted or unpublished
      var alive = found.map(function (c) { return c.dataset.handle; });
      writeWish(list.filter(function (h) { return alive.indexOf(h) > -1; }));
      if (!found.length) { emptyWish(grid); paintWish(); return; }
      grid.innerHTML = "";
      found.forEach(function (c) { c.style.opacity = 1; grid.appendChild(c); });
      paintWish();
    });
  }

  /* ------------------------------------------------------------ product page */
  function initPDP(root) {
    $$("[data-pdp]", root).forEach(function (pdp) {
      if (pdp._ncs) return; pdp._ncs = true;
      var form = $("[data-product-form]", pdp);
      var jsonEl = $("[data-variants]", pdp);
      var variants = []; try { variants = JSON.parse(jsonEl ? jsonEl.textContent : "[]"); } catch (e) {}
      var idInput = $("[data-variant-input]", pdp);
      var groups = $$("[data-option-index]", pdp);
      var addBtn = $("[data-pdp-add]", pdp), buyBtn = $("[data-pdp-buy]", pdp);
      var addLabel = $("[data-add-label]", pdp);
      var priceEl = $("[data-pdp-price]", pdp);
      var stockEl = $("[data-pdp-stock]", pdp);
      var qty = $("[data-qty-input]", pdp);
      var current = variants.filter(function (v) { return idInput && String(v.id) === idInput.value; })[0] || variants[0];

      function selected() {
        return groups.map(function (g) {
          var b = $('button[aria-pressed="true"]', g);
          return b ? b.dataset.value : null;
        });
      }
      function find(opts) {
        return variants.filter(function (v) { return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; }); })[0];
      }
      function paintOptions() {
        var sel = selected();
        groups.forEach(function (g, gi) {
          $$("button", g).forEach(function (b) {
            var trial = sel.slice(); trial[gi] = b.dataset.value;
            var match = variants.filter(function (v) { return v.options.every(function (o, i) { return o === trial[i]; }); })[0];
            var ok = !!match && match.available;
            b.disabled = !ok && b.getAttribute("aria-pressed") !== "true";
            b.classList.toggle("is-unavailable", !ok);
          });
        });
      }
      function paintPrice(v) {
        if (!priceEl || !v) return;
        var h = '<span class="now">' + formatMoney(v.price) + "</span>";
        if (v.compare > v.price) h += '<span class="was">' + formatMoney(v.compare) + '</span><span class="off">' + Math.round((v.compare - v.price) * 100 / v.compare) + "% off</span>";
        priceEl.innerHTML = h;
      }
      function paintStock(v) {
        if (!stockEl) return;
        if (!v) { stockEl.textContent = "This combination isn’t made"; stockEl.style.color = "#B03A3A"; return; }
        if (!v.available) { stockEl.textContent = "Out of stock"; stockEl.style.color = "#B03A3A"; return; }
        if (v.qty != null && v.qty <= 3 && v.qty > 0) { stockEl.textContent = "Only " + v.qty + " left"; stockEl.style.color = "var(--gold)"; return; }
        stockEl.textContent = "In stock"; stockEl.style.color = "var(--muted)";
      }
      function paintButtons(v) {
        var ok = !!v && v.available;
        if (addBtn) addBtn.disabled = !ok;
        if (buyBtn) buyBtn.disabled = !ok;
        if (addLabel) addLabel.textContent = ok ? "Add to bag" : (v ? "Sold out" : "Unavailable");
      }
      function showMedia(id) {
        if (!id) return;
        var t = $('[data-gal-thumbs] button[data-media-id="' + id + '"]', pdp);
        if (t) t.click();
      }
      function update(fromUser) {
        var v = find(selected());
        current = v;
        if (v && idInput) idInput.value = v.id;
        paintOptions(); paintPrice(v); paintStock(v); paintButtons(v);
        if (v && fromUser) {
          showMedia(v.media);
          if (window.history && history.replaceState) {
            var u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState({}, "", u.toString());
          }
        }
      }
      groups.forEach(function (g) {
        g.addEventListener("click", function (e) {
          var b = e.target.closest("button"); if (!b || b.disabled) return;
          $$("button", g).forEach(function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
          update(true);
        });
      });
      update(false);

      // Gallery
      var main = $("[data-gal-main]", pdp), mainImg = main && $("img", main);
      $$("[data-gal-thumbs] button", pdp).forEach(function (b, i, all) {
        b.addEventListener("click", function () {
          all.forEach(function (x) { x.setAttribute("aria-selected", "false"); });
          b.setAttribute("aria-selected", "true");
          if (!mainImg) return;
          mainImg.src = b.dataset.src; mainImg.srcset = b.dataset.srcset || "";
          if (window.anime && !window.matchMedia("(prefers-reduced-motion: reduce)").matches)
            window.anime({ targets: mainImg, opacity: [0.35, 1], scale: [1.03, 1], duration: 560, easing: "cubicBezier(.16,1,.3,1)" });
        });
      });
      if (main && mainImg) {
        main.addEventListener("click", function () { main.classList.toggle("is-zoom"); });
        main.addEventListener("mousemove", function (e) {
          if (!main.classList.contains("is-zoom")) return;
          var r = main.getBoundingClientRect();
          mainImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + "% " + ((e.clientY - r.top) / r.height * 100) + "%";
        });
      }

      // Quantity
      var dec = $("[data-qty-dec]", pdp), inc = $("[data-qty-inc]", pdp);
      if (dec) dec.addEventListener("click", function () { qty.value = Math.max(1, (+qty.value || 1) - 1); });
      if (inc) inc.addEventListener("click", function () {
        var cap = current && current.qty != null ? Math.max(1, current.qty) : 99;
        qty.value = Math.min(cap, (+qty.value || 1) + 1);
      });

      // Add to bag over Ajax; "Buy it now" keeps its native submit to checkout
      var lastSubmit = null;
      if (form) form.addEventListener("click", function (e) {
        var b = e.target.closest('button[type="submit"]'); if (b) lastSubmit = b;
      });
      if (form) form.addEventListener("submit", function (e) {
        var submitter = e.submitter || lastSubmit;
        if (submitter && submitter.hasAttribute("data-pdp-buy")) return;
        e.preventDefault();
        if (!current || !current.available) return;
        var title = $("h1", pdp) ? $("h1", pdp).textContent.trim() : "";
        var optionText = current.options.length && current.options[0] !== "Default Title" ? " (" + current.options.join(" / ") + ")" : "";
        addBtn.disabled = true;
        addToBag(current.id, Math.max(1, +qty.value || 1), title + optionText)
          .catch(function (err) { toast(err.message); })
          .then(function () { addBtn.disabled = !(current && current.available); });
      });
    });
  }

  /* ------------------------------------------------------------ recommendations */
  function initRecs(root) {
    $$("[data-recs]", root).forEach(function (el) {
      if (el._ncs || !el.dataset.url) return; el._ncs = true;
      if (el.querySelector(".pcard")) return;
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement("div"); d.innerHTML = html;
        var fresh = $("[data-recs]", d);
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
          paintWish();
          if (window.NCS_reveal) window.NCS_reveal(el);
        }
      }).catch(function () {});
    });
  }

  /* ------------------------------------------------------------ bag page */
  function cartSection() { return $("[data-cart-section]"); }
  function changeLine(line, quantity) {
    var host = cartSection(); if (!host) return;
    var id = host.dataset.cartSection;
    host.classList.add("is-busy");
    postJSON((R.cartChange || "/cart/change") + ".js", { line: Number(line), quantity: Math.max(0, quantity), sections: [id] })
      .then(function (data) {
        paintCartCount(data.item_count);
        var html = data.sections && data.sections[id];
        if (html) {
          var d = document.createElement("div"); d.innerHTML = html;
          var fresh = $("[data-cart-section]", d);
          if (fresh) host.innerHTML = fresh.innerHTML;
        } else { location.reload(); }
      })
      .catch(function (err) { toast(err.message); })
      .then(function () { host.classList.remove("is-busy"); });
  }
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-qty-change]");
    if (b) {
      var line = b.dataset.line, input = $('[data-line-qty="' + line + '"]');
      changeLine(line, (+input.value || 0) + Number(b.dataset.qtyChange));
      return;
    }
    var rm = e.target.closest("[data-line-remove]");
    if (rm && cartSection()) { e.preventDefault(); changeLine(rm.dataset.lineRemove, 0); return; }
    var ap = e.target.closest("[data-promo-apply]");
    if (ap) { applyPromo(); }
  });
  document.addEventListener("change", function (e) {
    var q = e.target.closest("[data-line-qty]");
    if (q) changeLine(q.dataset.lineQty, +q.value || 0);
    var note = e.target.closest("#CartNote");
    if (note) postJSON((R.cartUpdate || "/cart/update") + ".js", { note: note.value }).catch(function () {});
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && e.target.matches && e.target.matches("[data-promo-input]")) { e.preventDefault(); applyPromo(); }
  });
  function applyPromo() {
    var input = $("[data-promo-input]"); if (!input) return;
    var code = input.value.trim(); if (!code) { toast("Enter a promo code first"); return; }
    postJSON((R.cartUpdate || "/cart/update") + ".js", { discount: code })
      .then(function () { location.reload(); })
      .catch(function () { location.href = "/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(R.cart || "/cart"); });
  }

  /* ------------------------------------------------------------ filters */
  document.addEventListener("change", function (e) {
    var form = e.target.closest("[data-filter-form]");
    if (!form) return;
    if (e.target.matches("[data-price-range]")) return; // handled on release below
    submitFilters(form);
  });
  document.addEventListener("input", function (e) {
    var r = e.target.closest("[data-price-range]");
    if (!r) return;
    var out = $("[data-price-out]", r.closest(".fgroup"));
    if (out) out.textContent = formatMoney(Number(r.value) * 100);
  });
  document.addEventListener("change", function (e) {
    var r = e.target.closest("[data-price-range]");
    if (r) submitFilters(r.form);
  });
  function submitFilters(form) {
    $$("[data-price-range]", form).forEach(function (r) { r.disabled = Number(r.value) >= Number(r.dataset.max); });
    form.classList.add("is-busy");
    form.submit();
  }
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-filter-toggle]");
    if (!t) return;
    var panel = document.getElementById(t.getAttribute("aria-controls"));
    if (!panel) return;
    var open = panel.classList.toggle("is-open");
    t.setAttribute("aria-expanded", open ? "true" : "false");
  });

  /* ------------------------------------------------------------ boot */
  function boot(root) { paintWish(); initPDP(root || document); initRecs(root || document); }
  boot(document);
  renderWishlist();
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); if ($("[data-wishgrid]", e.target)) renderWishlist(); });
  window.addEventListener("pageshow", function (e) { if (e.persisted) refreshCount(); });
})();
